import i18n from "../../../translations/strings";
import landing from "../../../assets/landing-page/landing.jpg";
import { Colors } from "../../../colors";
import room from "../../../assets/landing-page/landing3.jpeg";

export const itemsCarouselLandingPage = [
  {
    description: i18n.t('landing.privateRoomsEvents'),
    img: landing,
    textColor: Colors.White
  },
  {
    description: i18n.t('landing.videoStreaming'),
    img: room,
    textColor: Colors.Primary
  },
]
